import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {
  pageSx,
  containerSx,
  mainTitleSx,
  sectionTitleSx,
  sectionTextSx,
} from "../privacy-policy/Page.sx";
import { Footer } from "../../components/Layout";

export default function TermsOfServicePage() {
  return (
    <Box sx={pageSx}>
      <Box sx={containerSx}>
        <Stack gap={3}>
          {/* Main Title */}
          <Typography component="h1" sx={mainTitleSx}>
            Terms of Service
          </Typography>

          {/* Intro */}
          <Typography sx={sectionTextSx}>
            This site is provided subject of your compliance with the terms and
            conditions set forth below. Please read the following information
            carefully. Your continued use of this site will indicate your
            agreement to be bound by these terms. If you do not agree to be
            bound by the terms and conditions, exit this site.
          </Typography>

          {/* Section 1 */}
          <Typography component="h2" sx={sectionTitleSx}>
            1. Restrictions on Use
          </Typography>
          <Typography sx={sectionTextSx}>
            All pages within this website and any material made available for
            download (collectively the "Site") are the property of Cledar SP.
            Z.o.o. and/or its affiliates or assigns ("Cledar", "We, "Us," or
            "Our"). The Site is protected by federal and international
            copyright, trademark, and other intellectual property laws. No
            portion of the materials on these pages may be reprinted,
            republished, modified, or distributed in any form without the
            express written permission of Cledar. Site for your own personal use
            or the internal use of your business. You shall keep intact any
            proprietary notices, including copyright notices, contained on any
            downloaded materials and shall comply with any applicable end user
            license agreements.
          </Typography>
          <Typography sx={sectionTextSx}>
            Any rights not expressly granted by these Terms and Conditions or
            any applicable end user license agreements are reserved by Us.
          </Typography>

          {/* Section 2 */}
          <Typography component="h2" sx={sectionTitleSx}>
            2. Trademark Notice
          </Typography>
          <Typography sx={sectionTextSx}>
            "Cledar" and associated artwork the logos, trademarks, and service
            marks of Cledar. All other trademarks, service marks and logos used
            in this Site are the trademarks, service marks or logos of their
            respective owners.
          </Typography>

          {/* Section 3 */}
          <Typography component="h2" sx={sectionTitleSx}>
            3. Warranty Disclaimer
          </Typography>
          <Typography sx={sectionTextSx}>
            This site, including any content or information contained within it
            or any site-related service, is provided "as is," with all faults,
            with no representations or warranties of any kind, either expressed
            or implied, including, but not limited to, the implied warranties of
            merchantability, fitness for a particular purpose, and
            noninfringement. You assume total responsibility and risk for your
            use of this site, site-related services, and hyperlinked websites.
          </Typography>
          <Typography sx={sectionTextSx}>
            Cledar, its affiliates and its contractors are neither responsible
            nor liable for any direct, indirect, incidental, consequential,
            special, exemplary, punitive, or other damages arising out of or
            relating to the site, site-related services, content or information
            contained within the site, and/or any hyperlinked website. Your sole
            remedy for dissatisfaction with the site, site-related services,
            and/or hyperlinked websites is to stop using the site and/or those
            services.
          </Typography>
          <Typography sx={sectionTextSx}>
            Although We attempt to ensure the integrity and accurateness of the
            Site, We make no guarantees as to the correctness or accuracy of the
            Site. It is possible that the Site could include inaccuracies or
            errors, and that unauthorized additions, deletions and alterations
            could be made to the Site by third parties. In the event that an
            inaccuracy arises, please inform Us so that it can be corrected.
            Information contained on the Site may be changed or updated without
            notice.
          </Typography>

          {/* Section 4 */}
          <Typography component="h2" sx={sectionTitleSx}>
            4. Confidential and Proprietary Information
          </Typography>
          <Typography sx={sectionTextSx}>
            We do not want to receive confidential or proprietary information
            from you through the Site. Please note that any information or
            material sent to Us through the Site will be deemed not to be
            confidential unless otherwise agreed in writing, or unless You are a
            Client under contract with Us. By sending Us any information or
            material, you grant Us an unrestricted, irrevocable, world-wide,
            royalty free license to use, reproduce, display, perform, modify,
            transmit, and distribute those materials or information, and you
            also agree that We free to use any ideas, concepts, know-how, or
            techniques that you send us for any purpose.
          </Typography>

          {/* Section 5 */}
          <Typography component="h2" sx={sectionTitleSx}>
            5. Choice of Law and Venue
          </Typography>
          <Typography sx={sectionTextSx}>
            These Terms and Conditions are entered into in the State of
            California and shall be governed by and construed in accordance with
            the laws of the State of California, exclusive of its choice of law
            rules.
          </Typography>
          <Typography sx={sectionTextSx}>
            Domestic Disputes. All parties to these Terms and Conditions submits
            to the exclusive jurisdiction of the state and federal courts
            sitting in the County of Marin in the State of California, and
            waives any jurisdictional, venue, or inconvenient forum objections
            to such courts. In any action to enforce these Terms and Conditions,
            the prevailing party shall be entitled to costs and attorneys',
            experts, and other professional's fees. In the event that any of the
            Terms and Conditions are held by a court or other tribunal of
            competent jurisdiction to be unenforceable, those provisions shall
            be limited or eliminated to the minimum extent necessary so that
            these Terms and Conditions shall otherwise remain in full force.
          </Typography>
          <Typography sx={sectionTextSx}>
            International Disputes. Any dispute, controversy or claim arising
            out of or relating to this Agreement or its amendments, including,
            without limitation, its formation, validity, enforceability,
            interpretation, performance, breach or termination, and related
            non-contractual claims, shall be mediated under the WIPO Mediation
            Rules. The mediation shall be in Geneva, Switzerland, and in
            English. Any dispute, controversy or claim not settled within 60
            days of commencing mediation shall, upon filing a Request for
            Arbitration by a party, be finally determined by binding arbitration
            under the WIPO Expedited Arbitration Rules. Alternatively, if,
            before the expiration of the 60 days, a party fails to complete the
            mediation, the dispute, controversy or claim shall, upon the filing
            of a Request for Arbitration by any other party, be referred to and
            finally determined by binding arbitration under the WIPO Expedited
            Arbitration Rules. The arbitration shall be in Geneva, Switzerland,
            and the arbitral proceedings shall be in English. The dispute,
            controversy or claim referred to arbitration shall be decided under
            the law of the State of California. The parties agree to bring any
            dispute in arbitration on an individual basis only, and not on a
            class or collective basis.
          </Typography>

          {/* Section 6 */}
          <Typography component="h2" sx={sectionTitleSx}>
            6. Entire Agreement
          </Typography>
          <Typography sx={sectionTextSx}>
            These Terms and Conditions constitute the entire agreement between
            Us and you pertaining to the subject matter of this Agreement. In
            its sole discretion, We may modify these Terms and Conditions by
            posting the revised version on this Site and you agree that each
            visit by you to this Site is a new transaction governed by the terms
            of use linked on this Site at that time.
          </Typography>

          {/* Section 7 */}
          <Typography component="h2" sx={sectionTitleSx}>
            7. No Unlawful or Prohibited Purpose
          </Typography>
          <Typography sx={sectionTextSx}>
            As a condition of your use of this Site, you warrant to Us that you
            will not use the Site for any purpose that is unlawful or prohibited
            by these Terms and Conditions.
          </Typography>

          {/* Section 8 */}
          <Typography component="h2" sx={sectionTitleSx}>
            8. Indemnification
          </Typography>
          <Typography sx={sectionTextSx}>
            To the extent permitted by applicable law, you agree to defend,
            indemnify and hold harmless Cledar, its affiliates, officers,
            directors, employees, agents, contractors, and assigns, from and
            against any and all claims, damages, obligations, losses,
            liabilities, costs or debt, and expenses (including but not limited
            to attorneys', experts', and other professionals' fees) arising
            from: (i) your use of and access to the Site; (ii) your violation of
            any term of these Terms; or (iii) your violation of any third party
            right, including without limitation any intellectual property,
            property, or privacy right. This defense and indemnification
            obligation will survive these Terms and your use of the Site.
          </Typography>

          {/* Section 9 */}
          <Typography component="h2" sx={sectionTitleSx}>
            9. Limitation of Liability
          </Typography>
          <Typography sx={sectionTextSx}>
            Use of the site and any content is at your own risk. In no event
            will cledar or its suppliers or affiliates, contractors, or assigns
            ("cledar parties"), be liable for any indirect, incidental,
            consequential, punitive or special damages in connection with these
            terms, whether or not such damages were foreseeable and even if the
            cledar parties were advised that such damages were likely or
            possible. In no event will the aggregate liability of the cledar
            parties to you for any and all claims arising in connection with
            this site or these terms exceed one hundred u.S. Dollars (u.S.D.
            $100.00). You acknowledge that this limitation of liability is an
            essential term between you and us relating to the provision of the
            site(s) and any content to you, and we would not provide access to
            the site(s) to you without this limitation. You agree that we will
            not be liable to you or any other party for any termination of your
            access to the site(s) or deletion of content.
          </Typography>

          {/* Section 10 */}
          <Typography component="h2" sx={sectionTitleSx}>
            10. Privacy
          </Typography>
          <Typography sx={sectionTextSx}>
            In the course or accessing and/or using the Site, We may obtain
            information about you. All uses of your personal information will be
            treated in accordance with our Privacy Policy, which forms an
            integral part of these Terms. If you use the Site you are accepting
            the terms and conditions of our Privacy Policy, as may be amended by
            Us. If you do not agree to have your information used in any of the
            ways described in the Privacy Policy, you must discontinue use of
            the Site.
          </Typography>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
}
